<template>
  <div class="container">
    <div class="search_box">
      <v-search :searchType="'maintenancePlan'" :limit="tableParams.limit"
        @searchParams="searchChange($event)"></v-search>
    </div>
    <div class="table_box">
      <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" stripe
        v-loading="tableLoading">
        <el-table-column property="number" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column property="carNumber" label="车牌号码">
        </el-table-column>
        <el-table-column property="carColorStr" label="车牌颜色">
        </el-table-column>
        <el-table-column property="carServiceStr" label="车辆营运性质">
        </el-table-column>
        <el-table-column property="validityPeriodTime" label="年审有效期" sortable>
        </el-table-column>
        <el-table-column property="secondaryMaintenanceTime" label="二级维护有效期" sortable>
        </el-table-column>
        <el-table-column property="technicalGradeTime" label="技术等级有效期" sortable>
        </el-table-column>
        <el-table-column property="planTypeStr" label="计划类型">
        </el-table-column>
        <el-table-column property="sinceLastMile" label="距上次二维行驶里程">
        </el-table-column>
        <el-table-column property="nextTimeDay" label="距下次二维天数">
        </el-table-column>
      </el-table>
    </div>
    <div class="paging_box">
      <!--  :current-page="currentPage4" -->
      <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]" :page-size.sync="tableParams.limit" :current-page.sync="tableParams.page"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import search from "@/components/search.vue";
import { exportExcel } from "@/utils/util";
export default {
  name: "maintenancePlan",
  data () {
    return {
      tableData: [],
      tableParams: {
        carColor: null,
        carNumber: "",
        carService: null,
        companyId: null,
        isIndex: false,
        limit: 10,
        page: 1,
        planType: null,
        isPage: true
      },
      total: 0,
      tableLoading: false,
    };
  },
  components: {
    "v-search": search,
  },
  props: {},
  created () {
    // this.getList();
  },
  methods: {
    getList (data) {
      this.tableParams.isPage = true;
      let params = data ? data : this.tableParams;
      this.tableLoading = true;
      this.$http.getDimensionalList(params).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error(res.msg);
        }
      });
    },
    // 事件处理函数
    async searchChange (value) {
      this.tableParams = value;
    },
    handleSizeChange (val) {
      this.tableParams.limit = val;
      this.tableParams.page = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.tableParams.page = val;
      this.getList();
    },
    downloadExport () {
      this.tableParams.isPage = false;
      this.$http.getDimensionalList(this.tableParams).then((res) => {
        if (res.code === 0) {
          const exportExcelList = res.data;
          // 表头
          const tHeader = [
            "序号",
            "车牌号码",
            "车牌颜色",
            "车辆营运性质",
            "年审有效期",
            "二级维护有效期",
            "技术等级有效期",
            "计划类型",
            "距上次二维行驶里程",
            "距下次二维天数"
          ];
          // table表格中对应的属性名
          const filterVal = [
            "number",
            "carNumber",
            "carColorStr",
            "carServiceStr",
            "validityPeriodTime",
            "secondaryMaintenanceTime",
            "technicalGradeTime",
            "planTypeStr",
            "sinceLastMile",
            "nextTimeDay"
          ];
          exportExcel(tHeader, filterVal, exportExcelList, this.$route.name);
        } else {
          this.$message.info(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/comm.less";
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/maintenancePlan.vue